import React from 'react';
import Footer from '../Components/Footer';
import Navbar from '../Components/Navbar';
import { Link } from 'react-router-dom';
import '../Styles/Work.css';

function Courses() {
  const courses = [
    {
      id: 1,
      title: 'Blockchain Fundamentals',
      description: 'Learn the basics of blockchain technology, including how it works, its key components, and its potential applications across various industries.',
      duration: '6 weeks',
      level: 'Beginner',
      image: 'https://images.unsplash.com/photo-1639762681057-1e73ca573554?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1374&q=80'
    },
    {
      id: 2,
      title: 'Advanced Cryptocurrency Trading',
      description: 'Master the art of cryptocurrency trading with advanced strategies, technical analysis, and risk management techniques.',
      duration: '8 weeks',
      level: 'Advanced',
      image: 'https://images.unsplash.com/photo-1621761191319-c6fb62004040?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1374&q=80'
    },
    {
      id: 3,
      title: 'Smart Contract Development',
      description: 'Learn to develop and deploy smart contracts on major blockchain platforms like Ethereum and Solana.',
      duration: '10 weeks',
      level: 'Intermediate',
      image: 'https://images.unsplash.com/photo-1639322537228-f7109b2325cc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1374&q=80'
    }
  ];

  return (
    <>
      <Navbar />
      <div className='banner banner2'>
        <h2>Our Courses</h2>
        <p>Home / Work With Us / Courses</p>
      </div>
      
      <div className='courses-container'>
        <div className='work-container'>
          <h1 data-aos="fade-up">Blockchain & Cryptocurrency Courses</h1>
          <p className='text-center' data-aos="fade-up" data-aos-delay="100">
            Our comprehensive courses are designed to take you from beginner to expert in the world of blockchain and cryptocurrency.
            Learn from industry experts and get hands-on experience with real-world projects.
          </p>
          
          <div className='course-cards'>
            {courses.map(course => (
              <div key={course.id} className='course-card' data-aos="fade-up" data-aos-delay={course.id * 100}>
                <div 
                  className='course-image'
                  style={{ backgroundImage: `url(${course.image})` }}
                ></div>
                <div className='course-content'>
                  <div className='d-flex justify-content-between align-items-center mb-2'>
                    <span className='badge bg-primary'>{course.level}</span>
                    <span className='text-muted'>{course.duration}</span>
                  </div>
                  <h3>{course.title}</h3>
                  <p>{course.description}</p>
                  <Link to="/book-call" className='enroll-btn'>Enroll Now</Link>
                </div>
              </div>
            ))}
          </div>
          
          <div className='text-center mt-5' data-aos="fade-up">
            <h3>Looking for something else?</h3>
            <p>Contact us for custom training programs tailored to your needs.</p>
            <Link to="/contact" className='work-button'>Contact Us</Link>
          </div>
        </div>
      </div>
      
      <Footer />
    </>
  );
}

export default Courses;
